export enum DisciplineTutorAssignType {
  Regular = 'REGULAR',
  Substitute = 'SUBSTITUTE',
}

export enum DisciplineGeneralModal {
  Duplicate = 'duplicate',
  Merge = 'merge',
  MergeConfirm = 'merge-confirm',
  Delete = 'delete',
}

export enum DisciplineBalanceReferenceType {
  Order = 'order',
  Subscription = 'subscription',
  Lesson = 'lesson',
}

export enum DisciplineBalanceAction {
  TopUp = 'top-up',
  Remove = 'remove',
}

export enum DisciplineFilesModal {
  Send = 'send',
  Pack = 'pack',
  DeletePack = 'delete-pack',
  Certificate = 'certificate',
}

export enum DisciplineFilePackOwner {
  Tutor = 'TUTOR',
  Discipline = 'DISCIPLINE',
}

export enum DisciplinePaymentOption {
  OneTime = 'ONE_TIME',
  Installment = 'INSTALLMENT',
}

export enum DisciplinePaymentProductType {
  OneTime = 'ONE_TIME',
  Subscription = 'SUBSCRIPTION',
}

export enum DisciplinePaymentLinksTab {
  PaymentLink = 'payment-link',
  PricingPage = 'pricing-page',
}

export enum DisciplineSubscriptionType {
  Monthly = 'MONTHLY',
  Biweekly = 'BIWEEKLY',
  FourWeeks = 'FOUR_WEEKS',
}

export enum DisciplineMessageSender {
  Email = 'EMAIL',
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP',
}

export enum DisciplineDeliveryStatus {
  Sent = 'sent',
  Queued = 'queued',
  Skipped = 'skipped',
  Failed = 'failed',
}

/** The four weekly-schedule wizards of the General info tab. */
export enum DisciplineScheduleFlow {
  Create = 'create',
  Change = 'change',
  ChangeTutor = 'change-tutor',
  SetupLessons = 'setup-lessons',
}

/** One modal of a weekly-schedule wizard; a flow walks its own sequence of them. */
export enum DisciplineScheduleStep {
  TutorReason = 'tutor-reason',
  Slots = 'slots',
  StartDate = 'start-date',
  EffectiveDate = 'effective-date',
  Pace = 'pace',
  Filters = 'filters',
  AssignTutor = 'assign-tutor',
  Confirm = 'confirm',
  SetupLessons = 'setup-lessons',
}

export enum DisciplineScheduleEffectiveMode {
  Now = 'now',
  Specify = 'specify',
}

/** The run types the wizards may start; the system types are refused by the API. */
export enum DisciplineActivationRunType {
  Manual = 'MANUAL',
  ChangeTutor = 'CHANGE_TUTOR',
}

export enum DisciplineTutorChangeReason {
  TutorFitIssue = 'TUTOR_FIT_ISSUE',
  ClientSchedule = 'CLIENT_SCHEDULE',
  TutorUnavailableToContinue = 'TUTOR_UNAVAILABLE_TO_CONTINUE',
}

export enum DisciplineAllocationStatus {
  Available = 'available',
  PartlyAvailable = 'partly-available',
  Busy = 'busy',
}

/** The kanban card tabs a discipline page opens the card on (the legacy kanban `KanbanTab` values). */
export enum DisciplineKanbanTab {
  Activation = 'ACTIVATION',
  Comments = 'COMMENTS',
}
